import { type ReactNode } from "react";

import Modal from "../Modal";
import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";
import classnames from "classnames";

export interface BulkATWPopupBaseProps {
  classNames?: string;
  onClose: () => void;
  footerChildren?: ReactNode;
  children?: ReactNode;
  title?: string;
}

const ACTWPopupBase = ({ classNames, onClose, footerChildren, title, children }: BulkATWPopupBaseProps) => {
  const isTablet = useIsMinTabletSize();

  return (
    <Modal
      onClose={onClose}
      footerChildren={footerChildren}
      title={title}
      modalClassName={classnames(classNames)}
    >
      {children}
    </Modal>
  );
};

export default ACTWPopupBase;
